export default __webpack_public_path__ + "static/lined_paper-a87190d9741ed3175b16501b66ef47e9.png";